import React from 'react';
import { AutoSizer } from 'react-virtualized';
import { Observer, observer } from 'mobx-react-lite';

interface ObservableAutoSizerProps {
    customChildren: ({ width, height }: { width: number, height: number }) => React.ReactElement | null
}

export default observer<ObservableAutoSizerProps>(function ObservableAutoSizer({ customChildren }) {
    return (
        <AutoSizer>
            {(sizeProps) => <Observer>{() => customChildren(sizeProps)}</Observer>}
        </AutoSizer>
    )
});
